import { MESSAGE_TYPE, PUSH_NOTIFICATION_MODULE } from '../constants';
import { RoutesPaths } from '../Router/constant';
import api from '../services/api'
import { chatMediaAddAction, reOrganiseMessage } from './chat';
import { uploadMultipleFileAction } from './files';
import { GET_CHAT_LIST, SET_UNREAD_COUNT, UPDATE_CHAT_LAST_MESSAGE } from './types';

export const getAllChatList = () => (dispatch) => {
  return api.getChats().then((response) => {
    dispatch({ type: GET_CHAT_LIST, payload: response.data || [] })
    return response.data;
  });
}

export const updateChatLastMessage = (chatId, lastMessage) => ({
  type: UPDATE_CHAT_LAST_MESSAGE,
  payload: { chatId, lastMessage },
});

export const adminChatMessage = (payload) => {
  return api.adminChat(payload).then((response) => {
    return response.data;
  });
}

export const getUnreadChatAction = () => (dispatch) => {
  return api.getUnreadChat().then((response) => {
    dispatch({ type: SET_UNREAD_COUNT, payload: response.data || [] })
    return response.data;
  });
}